import React from "react";
import { Form, Col } from "react-bootstrap";
import { InputField } from "../../../components/InputField";

const XTTSFields = ({ file, setFileInputFilled, setVoiceModel }) => {
    const validateFile = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const isValidExtension = selectedFile.name.toLowerCase().endsWith(".wav");
            const isValidSize = selectedFile.size <= 10 * 1024 * 1024; // 10MB

            if (!isValidExtension) {
                alert("O arquivo deve ter a extensão .wav");
                event.target.value = ""; // Reseta o input
                setFileInputFilled(false);
                setVoiceModel(null);
                return;
            }

            if (!isValidSize) {
                alert("O arquivo deve ter menos de 10MB");
                event.target.value = ""; // Reseta o input
                setFileInputFilled(false);
                setVoiceModel(null);
                return;
            }

            setVoiceModel(selectedFile);
            setFileInputFilled(true);
        } else {
            setFileInputFilled(false);
            setVoiceModel(null);
        }
    };

    return (
        <Form.Row>
            <Form.Group as={Col} lg="6" xs="12">
                <InputField
                    type="file"
                    name="voiceSample"
                    label="Voice Sample (arquivo .wav, máx 10MB)"
                    accept=".wav"
                    onChange={validateFile}
                    required
                />
                {file && typeof file === 'string' && (
                    <small style={{ color: "gray", marginTop: "5px", display: "block" }}>
                        Arquivo atual: {file.split('/').pop()}
                    </small>
                )}
            </Form.Group>
        </Form.Row>
    );
};

export default XTTSFields;